module.exports = __webpack_public_path__ + "static/media/7.8b5d2d0d.svg";